import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { lazy, Suspense } from 'react'
import { MarkerType } from '@app/components/core/map/markerConfig'
import { SectionHeader } from '../blocks/SectionHeader'
import { AppearItem } from '../blocks/AppearInViewport'

const SingleMarkerMap = lazy(() =>
  import('@app/components/core/map/SingleMarkerMap').then((module) => ({
    default: module.SingleMarkerMap,
  })),
)

export type LocationSectionType = {
  type: 'location'
  title: string
  subtitle: string
  lat: number
  long: number
  marker: MarkerType
}

export const LocationContentSection = ({
  title,
  subtitle,
  lat,
  long,
  marker,
}: LocationSectionType) => {
  return (
    <Column alignItems="stretch">
      <AppearItem staggerIndex={0}>
        <SectionHeader title={title} />
      </AppearItem>
      <AppearItem staggerIndex={1}>
        <Text.Medium>{subtitle}</Text.Medium>
      </AppearItem>
      <AppearItem staggerIndex={2}>
        <Suspense>
          <SingleMarkerMap
            lat={lat}
            long={long}
            zoom={15}
            marker={marker}
            height="25rem"
          />
        </Suspense>
      </AppearItem>
    </Column>
  )
}
